import { Box, Divider } from '@mui/material';
import styled from 'styled-components';

export const ProfilePageWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  height: 100%;

  background: ${({ theme }) => theme.palette.grey[100]};
`;

export const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px;
  gap: 24px;

  max-width: 877px;
  width: 100%;
`;

export const PageHeading = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
`;

export const FormWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 32px;

  width: 100%;

  background: ${({ theme }) => theme.palette.base.background};
  box-shadow: ${({ theme }) => theme.shadows[26]};
  border-radius: 8px;
`;

export const FieldsDivider = styled(Divider)`
  height: 1px;
  width: 100%;
  background: ${({ theme }) => theme.palette.grey[200]};
`;

export const FieldContent = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px;
  gap: 32px;
  width: 100%;
`;

export const InputFields = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 100%;
`;

export const ActionsButtons = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 12px;
  width: 100%;
`;
